import { SectionTopMenu } from '@vilibets/vilibets-uikit/dist/molecules/SectionTopMenu/SectionTopMenu';

const WelcomeBonds = ({ children }) => {
  return (
    <div className="flex flex-col" id="header-menu">
      <div className="flex intermedium:child:w-auto mb-5">
        <h1 className="font-bold text-2xl text-black-12 dark:text-accent-dark">Bonos de bienvenida</h1>
      </div>
      <SectionTopMenu
        links={[
          {
            title: 'Bonos disponibles',
            link: '/welcome-bonds/available',
          },
          {
            title: 'Bonos completados',
            link: '/welcome-bonds/completed',
          },
          {
            title: 'Bonos borrados',
            link: '/welcome-bonds/deleted',
          },
        ]}
      />

      <section className="flex flex-col pb-5 grow">{children}</section>
    </div>
  );
};

export default WelcomeBonds;
